import { jsx as _jsx } from "react/jsx-runtime";
import { RemixBrowser } from '@remix-run/react';
import { hydrate as reactHydrate } from 'react-dom';
export function hydrate() {
    reactHydrate(_jsx(RemixBrowser, {}), document);
}
